// Termos de Uso e Política de Privacidade (conta-login, AC-088). O texto mora nas traduções
// (namespace "legal"); aqui ficam os dados do responsável — pessoa física, os mesmos do cadastro no
// Stripe, sem empresa (decisão do usuário em 03/11/2026, ASM-042).

export type LegalDoc = 'terms' | 'privacy';

/** data da última atualização dos dois textos (AAAA-MM-DD) */
export const LEGAL_UPDATED = '2026-11-03';

/** contato para dúvidas, pedidos de dados, exclusão e reembolso (ASM-043) */
export const LEGAL_CONTACT = 'suporte@beedoit.app';

/** responsável pela Plataforma e controlador dos dados (Decreto 7.962/2013, art. 2º) */
export const LEGAL_OWNER = 'Gabriel Bernardes Machado Oliveira Gherardi';
export const LEGAL_DOCUMENT = 'CPF 070.368.786-73';
export const LEGAL_ADDRESS = 'Rua Bernardo Monteiro, 1000, Centro, Contagem – MG, Brasil';
/** foro eleito; o consumidor pode sempre usar o do seu domicílio (CDC, art. 101, I) */
export const LEGAL_FORUM = 'Contagem – MG';

/** valores trocados dentro dos textos: {{owner}}, {{document}}, {{address}}, {{forum}}, {{contact}} */
export const LEGAL_VARS = {
  owner: LEGAL_OWNER,
  document: LEGAL_DOCUMENT,
  address: LEGAL_ADDRESS,
  forum: LEGAL_FORUM,
  contact: LEGAL_CONTACT,
} as const;

/** seções obrigatórias, na ordem — todo idioma tem exatamente estas (AC-088) */
export const LEGAL_SECTIONS: Record<LegalDoc, readonly string[]> = {
  terms: [
    'definitions',
    'responsible',
    'service',
    'account',
    'minors',
    'trial',
    'payments',
    'cancel',
    'refund',
    'prices',
    'use',
    'content',
    'ip',
    'thirdparty',
    'updates',
    'availability',
    'security',
    'privacy',
    'warranties',
    'liability',
    'indemnity',
    'forcemajeure',
    'termination',
    'changes',
    'notices',
    'general',
    'law',
    'contact',
  ],
  privacy: [
    'definitions',
    'controller',
    'scope',
    'principles',
    'data',
    'sources',
    'purposes',
    'sharing',
    'transfers',
    'security',
    'incidents',
    'retention',
    'rights',
    'requests',
    'automated',
    'minors',
    'device',
    'communications',
    'thirdlinks',
    'changes',
    'contact',
  ],
};

export interface LegalSection {
  id: string;
  title: string;
  body: string[];
}
